export interface AnyObject extends Object {
    [key: string]: any;
}